import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/userpanel";




class UserPanelService {

 


  getusersdata() {
    return axios
      .get(API_URL + "/userdata" , {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }

  getcontractorsdata() {
    return axios
      .get(API_URL + "/contractorsdata" , {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }

  getusercontractorsdata(user_id:number) {
    //console.log(query)
    return axios
    .get(API_URL + '/usercontractorsdata/'+user_id)
    .then(response => {
        return response.data;
    });
}

  getsummarydata() {
    return axios
      .get(API_URL + "/summarydata" , {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }

  getnotedata() {
    return axios
      .get(API_URL + "/notedata" , {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }


 

}

export default new UserPanelService();